var _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSpcialistes(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 70,
    height: 70,
    viewBox: "0 0 70 70",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M61.6281 70H8.2945C3.73252 70 0 66.3027 0 61.6914V8.30861C0 3.73887 3.69105 0 8.2945 0H61.6281C66.1901 0 69.9226 3.69733 69.9226 8.30861V61.7329C69.9226 66.3027 66.1901 70 61.6281 70Z",
    fill: "#2F4C87"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M34.9576 32.5C39.0927 32.5 42.4449 29.1421 42.4449 25C42.4449 20.8579 39.0927 17.5 34.9576 17.5C30.8225 17.5 27.4703 20.8579 27.4703 25C27.4703 29.1421 30.8225 32.5 34.9576 32.5Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M17.4873 55C17.4873 45.335 25.309 37.5 34.9576 37.5C44.6062 37.5 52.4279 45.335 52.4279 55H17.4873Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSpcialistes);
export default __webpack_public_path__ + "static/media/spécialistes.aa4b802620b7e2713c2debbb24ed2ce9.svg";
export { ForwardRef as ReactComponent };